import { GetterTree } from 'vuex';

import { SubscriptionsStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<SubscriptionsStateI, RootStateI> = {
};
